import { isCorpDomain } from '@authFlow/utils/requestsToBackend/isCorpDomain';
import { storageManager } from '@authFlow/utils/SessionStorageManager';
import { getPersonalisedPlan } from '@authFlow/utils/getPersonalisedPlan';

export const getUserEmailDomain = (email: string) => {
  if (email && email !== 'undefined') {
    return email.split('@')[1];
  }

  return null;
};

export const updateUserStorageData = (newData: Record<string, any>) => {
  const currentUserData = storageManager.get('userData') || {};

  storageManager.set({
    userData: {
      ...currentUserData,
      ...newData,
    },
  });
};

export const updateUserStorageDataAfterAuth = async (email: string) => {
  const emailDomain = getUserEmailDomain(email);

  const isCorp = await isCorpDomain();
  const corpEmailDomain = isCorp ? { emailDomain: emailDomain } : null;
  const personalisedPlan = await getPersonalisedPlan();

  updateUserStorageData({
    ...corpEmailDomain,
    isCorp,
    personalisedPlan,
  });
};
